/* Korpa — Jeremić Satovi
   1) "Dodaj u korpu" na karticama (početna) dodaje preko AJAX-a i otvara fioku korpe.
   2) Posle dodavanja (kartica ili stranica proizvoda) u fioci se prikazuje potvrda.
   3) Poruke o greškama koje Shopify vraća na engleskom prikazuju se na srpskom.
   Tekstovi dolaze iz prevoda teme (window.jscCartStrings u layout/theme.liquid). */
(function () {
  if (window.__jscCartReady) return;
  window.__jscCartReady = true;

  var S = window.jscCartStrings || {};

  /* ---------- prevod Shopify grešaka ---------- */
  function translate(message) {
    if (!message) return S.error || '';
    var m = String(message);
    if (/sold out|is not available|unavailable/i.test(m)) return S.soldOut || m;
    if (/are in your cart|can.t add more|can only add|maximum|only \d+ items? (were|was) added/i.test(m)) return S.maxQty || m;
    if (/cannot find variant|parameter missing|something went wrong/i.test(m)) return S.error || m;
    return m;
  }

  var ERROR_SELECTOR = '.product-form__error-message, .cart-item__error-text, #CartDrawer-CartErrors, #cart-errors';

  function translateIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(ERROR_SELECTOR).forEach(function (el) {
      var text = el.textContent.trim();
      if (!text || !/[a-z]{3,}/i.test(text)) return;
      var translated = translate(text);
      if (translated && translated !== text) el.textContent = translated;
    });
  }

  function watch(el) {
    if (!el || el.__jscWatched) return;
    el.__jscWatched = true;
    new MutationObserver(function () { translateIn(el); }).observe(el, { childList: true, subtree: true, characterData: true });
  }

  function watchAll() {
    document.querySelectorAll('product-form, cart-drawer, cart-items, #main-cart-footer').forEach(watch);
  }

  /* ---------- potvrda u fioci ---------- */
  function markAdded(title) {
    setTimeout(function () {
      var el = document.querySelector('cart-drawer .jsc-cart-added');
      if (!el) return;
      el.textContent = (S.added || '') + (title ? ': ' + title : '');
      el.hidden = false;
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      var data = event.cartData || {};
      markAdded(data.product_title || data.title || '');
    });
  }

  /* ---------- brzo dodavanje sa kartice ---------- */
  function showCardError(form, message) {
    var box = form.parentElement.querySelector('.jsc-card__error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'jsc-card__error';
      box.setAttribute('role', 'alert');
      form.insertAdjacentElement('afterend', box);
    }
    box.textContent = message;
    setTimeout(function () { if (box.parentElement) box.remove(); }, 5000);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.jsc-card__form')) return;

    var drawer = document.querySelector('cart-drawer');
    // bez fioke (ili bez JS-a) forma se šalje normalno i vodi na /cart
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    }

    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.append('quantity', '1');
    formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
    formData.append('sections_url', window.location.pathname);
    if (button && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          showCardError(form, translate(response.description || response.message));
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jsc-card', productVariantId: formData.get('id'), cartData: response });
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(response);
        markAdded(response.product_title || response.title || '');
      })
      .catch(function () {
        showCardError(form, S.error || '');
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-loading');
        }
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAll);
  } else {
    watchAll();
  }
})();
